import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AcknowledgementService } from '../core/services/acknowledgement.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acknowldgement-dialog',
  templateUrl: './acknowldgement-dialog.component.html',
  styleUrls: ['./acknowldgement-dialog.component.scss']
})
export class AcknowldgementDialogComponent implements OnInit {

  constructor(  @Inject(MAT_DIALOG_DATA) public data,
  @Inject(DOCUMENT) private document: Document,
  public dialogRef: MatDialogRef<AcknowldgementDialogComponent>,
private acknowledgeService:AcknowledgementService,
private router: Router) { }
  popupData:any;
  agreeFlag=false;
  ngOnInit() {
    this.popupData=this.data;
    console.log(this.popupData)
    console.log(this.popupData.responseData.consentOptions)
    this.loadCiscoStyles('client-cisco.css');
  }
  closeDialog(){
    this.dialogRef.close(false)
  }
  loadCiscoStyles(styleName) {
    const head = this.document.getElementsByTagName('head')[0];
    const styleLink = this.document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.classList.add('cisco_styles')
    styleLink.href = styleName;
    head.appendChild(styleLink);
  };

  userAcknowledgement(selectedData){
  
    let req:any={};
    req.acknowledgementId=this.popupData.responseData.id;
    req.consent=selectedData.consent;
    req.hasSeen=true;
    this.acknowledgeService.captureUserAcknowledgement(req).subscribe(reseponse=>{
    if(reseponse){
      this.dialogRef.close(false)
    }
   }) 
  }
  navigateAndClose(data){
    this.dialogRef.close();
  console.log(data)

  // Split the data to get the URL and query string
  const navigateProp = data.navigateTo.split('?')[0]; // Get the route path without query params
  const queryParamsString = data.navigateTo.split('?')[1]; // Get the query params as a string

  // Convert the query string into an object
  const queryParams = this.convertQueryParams(queryParamsString);
console.log(queryParams)
  // Navigate with query params
  this.router.navigate([navigateProp], { queryParams });
}

// Helper function to convert query string to an object
convertQueryParams(queryParamsString: string): { [key: string]: string } {
  const params = queryParamsString ? queryParamsString.split('&') : [];
  const queryParams: { [key: string]: string } = {};

  params.forEach(param => {
    const [key, value] = param.split('=');
    if (key && value) {
      queryParams[key] = value;
    }
  });

  return queryParams;
  }
}
